import * as d3 from 'd3-selection'

function format (formatter, val) {
  return (formatter || (x => x))(val)
}

function header (el, total, totalLabel) {
  el.append('div')
      .attr('class', 'sb-chart-header')
      .select(function (d) {
        let header = d3.select(this)
                       .html(null)
                       .classed('multi-row-split', total && d[0].header.length > 1)

        if (!d[0].header) {
          return
        }

        let container = header.append('div')
                              .attr('class', 'title-row-container')
          , titles = container.selectAll('.title-row')
                              .data(d[0].header)
                              .enter()
                              .append('span')
                              .attr('class', 'sb-chart-header-title title-row')
                              .html(String)

        if (d[0].headerOverride) {
          titles.html(String)
        } else {
          titles.text(String)
        }

        if (total) {
          container.classed('split', true)
          let div = header.append('div')
                          .attr('class', 'sb-chart-header-total')

          div.append('span')
             .attr('class', 'sb-chart-header-label')
             .text(`${totalLabel}:`)

          div.append('span')
             .attr('class', 'sb-chart-header-value')
             .text(format(d[0].formatter, total))
        }
      })
}

function body (el) {
  let div = el.append('div')
              .attr('class', d => `sb-chart-body ${d.length > 1 ? 'multi' : 'single'}`)
              .style('grid-template-columns',d => {
                if (d.length > 1) {
                  // Check out how many columns are in the row
                  return ['25px'].concat(...new Array(d[0].cols.length - 1).fill('fit-content(200px)')).join(' ')
                } else {
                  return '100%' // one full column
                }
              })
              .selectAll('.cell')
              .data(d => d.map(row => row.cols).flat())
              .enter()
              .append('div')
              .attr('class', function (d, i, all) {
                let rows = d3.select(this.parentNode).datum()
                  , cols = rows[0].cols.length
                  , clazzes = ['cell']

                if (d.clazz) {
                  clazzes.push(d.clazz)
                }

                if (d.color) {
                  d3.select(this)
                    .style('color', d.color)
                }

                if (d.vars) {
                  this.style.setProperty(`--${d.vars.name}`, d.vars.value)
                }

                if (i >= all.length - cols) {
                  clazzes.push('bottom-row')
                }
                return clazzes.join(' ')
              })

    div.filter(d => {
          let clazz = d.clazz || ''
            , clazzes = clazz.split(' ')
          return clazzes.includes('regression-arrow')
        })
        .append('div') // Empty div for styling the arrow

    div.append('div').text(d => d.text || '') // This is needed to properly truncate text. See impact #46838

}

export default function (rows, chart) {
  if (!rows.length) {
    return
  }

  let total = undefined
  if (rows.length > 1 && rows.every(s => s.stackBy)) {
    // A stack, calculate a total
    total = rows.map(s => s.raw)
                .reduce((p, c) => p + c)
    total = rows[0].format(total)
  }

  return d3.select(document.createElement('div'))
           .data([rows])
           .call(header, total, chart.datum().tooltip.totalLabel)
           .call(body)
           .html()
}
